// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__RJh7j","control":"Checkout_control__YLRfl","actions":"Checkout_actions__CzPkL","submit":"Checkout_submit__2I-fx","invalid":"Checkout_invalid__0KpgD"};